// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"c96c239e","210":"b0d305dc","243":"03df9823","343":"743b4990","364":"a66f977b","427":"b3504c1b","435":"64c0b5da","479":"5c1bf075","484":"68ee8041","487":"0b816247","529":"1762f21f","540":"1b921bf1","545":"d31c0b9b","683":"43680012","768":"db2488b0","912":"aaa01a18"}[chunkId] + ".chunk.js";
};